import styled, { css } from 'styled-components';
var Wrapper = styled.div.withConfig({
  displayName: "Selectstyles__Wrapper",
  componentId: "oexq8w-0"
})(["display:flex;flex-direction:column;width:", ";margin-bottom:", ";"], function (props) {
  return props.wrapperWidth || '100%';
}, function (props) {
  return "".concat(props.marginBottom, "px");
});
var Label = styled.label.withConfig({
  displayName: "Selectstyles__Label",
  componentId: "oexq8w-1"
})(["min-height:19px;font-weight:", ";margin-bottom:", ";& span{color:", ";margin-left:8px;font-size:", ";display:inline-block;text-transform:capitalize;}"], function (props) {
  return props.theme.font.weight.bold;
}, function (props) {
  return props.hasSecondLine ? '5px' : '10px';
}, function (props) {
  return props.theme.color.monochrome.base;
}, function (props) {
  return props.theme.font.size.caption;
});
var Hint = styled.span.withConfig({
  displayName: "Selectstyles__Hint",
  componentId: "oexq8w-2"
})(["min-height:14px;font-size:", ";font-weight:", ";color:", ";margin-bottom:5px;"], function (props) {
  return props.theme.font.size.caption;
}, function (props) {
  return props.theme.font.weight.bold;
}, function (props) {
  return props.theme.color.semantic.error.base;
});
var SelectRow = styled.div.withConfig({
  displayName: "Selectstyles__SelectRow",
  componentId: "oexq8w-3"
})(["position:relative;max-width:", ";&::before,&::after{content:'';display:block;max-height:44px;pointer-events:none;position:absolute;top:4px;bottom:4px;background:white;}&::before{width:min(10%,50px);right:42px;background:linear-gradient(90deg,rgba(255,255,255,0) 0%,rgba(255,255,255,1) 100%);}&::after{z-index:0;right:2px;width:41px;border-radius:0 3px 3px 0;}"], function (props) {
  return props.maxWidth || 'none';
});
var Select = styled.select.withConfig({
  displayName: "Selectstyles__Select",
  componentId: "oexq8w-4"
})(["width:100%;margin:1px;padding:12px 17px 13px 15px;padding-left:", ";padding-right:", ";font-size:", ";font-family:", ";color:", ";background-color:", ";border:", ";border-radius:", ";&::placeholder{color:", ";}-webkit-appearance:none;-moz-appearance:none;&:-moz-focusring{color:transparent;text-shadow:0 0 0 #000;}&::-ms-expand{display:none;}&:-webkit-autofill,&:-webkit-autofill:hover,&:-webkit-autofill:focus{-webkit-box-shadow:0 0 0px 1000px #ffffff inset !important;}", " ", " ", ""], function (props) {
  return props.leftIcon ? "calc(".concat(props.leftIconWidth, " + 24px)") : '15px';
}, function (props) {
  return props.rightIcon ? "calc(".concat(props.rightIconWidth, " + 24px)") : '15px';
}, function (props) {
  return props.theme.font.size.base;
}, function (props) {
  return props.theme.font.family.base;
}, function (props) {
  return props.theme.color.monochrome.dark;
}, function (props) {
  return props.theme.color.monochrome.white;
}, function (props) {
  return "".concat(props.theme.size.border.width.sm, " solid ").concat(props.theme.color.monochrome.base);
}, function (props) {
  return props.theme.size.border.radius.base;
}, function (props) {
  return props.theme.color.monochrome.base;
}, function (props) {
  return props.error && css(["border-width:", ";border-radius:", ";border-color:", ";color:", ";"], props.theme.size.border.width.lg, props.theme.size.border.radius.lg, props.theme.color.semantic.error.base, props.theme.color.monochrome.dark);
}, function (props) {
  return props.disabled && css(["opacity:0.35;cursor:not-allowed;background-color:", ";border-color:", ";color:", ";"], props.theme.color.monochrome.white, props.theme.color.monochrome.base, props.theme.color.monochrome.base);
}, function (props) {
  return !props.error && !props.disabled && css(["&:hover,&:active,&:focus{border-color:", ";border-width:", ";border-radius:", ";margin:0;}&:active,&:focus{border-color:", ";color:", ";outline:none;}"], props.theme.color.monochrome.dark, props.theme.size.border.width.md, props.theme.size.border.radius.md, props.theme.color.palette['brand-1-light'], props.theme.color.monochrome.darker);
});
var SelectArrow = styled.div.withConfig({
  displayName: "Selectstyles__SelectArrow",
  componentId: "oexq8w-5"
})(["position:absolute;top:calc(50% - 12px);right:15px;z-index:2;pointer-events:none;"]);
export { Wrapper, SelectRow, Select, SelectArrow, Label, Hint };